import React from "react";
import { Tabs } from "@heroui/react";
import { useLocale } from "../context/LocaleContext";

const STATUSES = [
  { value: "all", key: "withdrawals.statusFilter.all" },
  { value: "submitted", key: "withdrawals.statusFilter.submitted" },
  { value: "in_review", key: "withdrawals.statusFilter.in_review" },
  { value: "accepted", key: "withdrawals.statusFilter.accepted" },
  { value: "rejected", key: "withdrawals.statusFilter.rejected" },
  { value: "partially_accepted", key: "withdrawals.statusFilter.partially_accepted" },
  { value: "closed", key: "withdrawals.statusFilter.closed" }
];

export function PortalStatusTabs({ active = "all", onChange, children }) {
  const { t } = useLocale();
  const selectedKey = active || "all";

  return (
    <div className="portal-withdrawals-layout">
      <Tabs
        className="portal-status-tabs w-full max-w-[220px]"
        orientation="vertical"
        selectedKey={selectedKey}
        onSelectionChange={(key) => onChange(key === "all" ? "" : key)}
      >
        <Tabs.ListContainer>
          <Tabs.List
            aria-label={t("withdrawals.pageTitle")}
            className="portal-status-tabs__list w-full *:w-full *:justify-start *:px-3 *:py-2 *:text-sm *:font-medium *:data-[selected=true]:text-accent-foreground"
          >
            {STATUSES.map((status) => (
              <Tabs.Tab key={status.value} id={status.value}>
                {t(status.key)}
                <Tabs.Indicator className="bg-accent" />
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>

      {children ? <div className="portal-withdrawals-layout__content">{children}</div> : null}
    </div>
  );
}
